<template>
  <div class="go-buy container desktop-buy">
    <span class="price-course"
      >$ {{ item.data.price }} <span class="usd">USD</span> </span
    ><br />
    <div class="add-course-button mt-6 cursor-pointer" @click="addToCart">
      Agregar al Carrito
    </div>
    <router-link
      to="/v2/cart"
      tag="div"
      class="add-cart-button mt-6 cursor-pointer"
      >Ir al carrito</router-link
    >
    <div class="stats text-skin-primary mt-10">
      <div class="item text-skin-primary flex">
        <img src="../assets/icono_clases.svg" class="mr-3" alt="" />
        {{ number_lesson }} Clases
      </div>
      <div class="item text-skin-primary flex">
        <img src="../assets/usuario.svg" class="mr-4" alt="" />
        {{ item.users_in_course }} Alumnos
      </div>
      <div class="item text-skin-primary flex">
        <img src="../assets/icono_audio.svg" class="mr-3" alt="" />
        Audio: Español
      </div>
      <div class="item text-skin-primary flex">
        <img src="../assets/icono_certificate.svg" class="mr-3" alt="" />
        Certificate al Finalizar
      </div>
    </div>
  </div>
</template>

<script>
import toastr from "toastr";

export default {
  props: {
    number_lesson: {
      type: Number,
    },
    item: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    addToCart() {
      this.$store
        .dispatch("shopingCart/addCart", this.item)
        .then(() => {
          toastr.success("Curso agregado con exito");
        });
    },
  },
};
</script>
